import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { IStoreSettings } from '../../../../../../common/common-interfaces/store-settings';
import { IStoreSummaryData } from '../../../../../../common/common-interfaces/store-statistics';
import { Api } from '../../services/api';
import { Globals } from '../../services/globals';
import moment from 'moment';
import { Utility } from 'src/app/services/utility';
import { IAdminNotification } from '../../../../../../common/common-interfaces/admin-notification';
import { MatSidenav } from '@angular/material/sidenav'; // Import MatSidenav from Angular Material library

@Component({
    selector: 'admin-panel',
    templateUrl: './admin-panel.component.html',
    styleUrls: ['./admin-panel.component.scss'],
    standalone: false
})
export class AdminPanelComponent {
  adminKey: string;
  adminNotifications: IAdminNotification[] = [];

  @ViewChild('notificationsPanel', { static: false })
  notificationsPanel: MatSidenav;

  constructor(private api: Api, private router: Router, private route: ActivatedRoute, public globals: Globals, public utility: Utility) {

  }

  async setAdminKey() {
    this.globals.adminKey = this.adminKey;
    let stores = await this.api.admin().get<any>(`/stores`);
    if (stores.length)
      this.globals.setAdminKey(this.adminKey);
  }

  async ngOnInit() {
    this.globals.loadAdminKey();
    await this.api.loadCurrentUser();
    await this.fetchNotifications();
  }

  async acknowledge(notification) {
    await this.api.admin().post<any>(`/admin-notifications/${notification._id}/acknowledge`, {});
    notification.acknowledge = {
      date: new Date()
    };
    this.adminNotifications = this.adminNotifications.filter(n => !n.acknowledge);
  }

  async fetchNotifications() {
    let adminOnly = true;
    if(this.globals.currentUser && this.globals.currentUser.username == 'emil')
      adminOnly = false;
    this.adminNotifications = await this.api.admin().get<any>(`/admin-notifications/latest?adminOnly=${adminOnly}`);
    console.log(this.adminNotifications);
  }

  openNotifications() {
    console.log(this.notificationsPanel);
    this.notificationsPanel.open();
  }

  closeNotifications() {
    console.log(this.notificationsPanel);
    this.notificationsPanel.close();
  }




}
